import React from "react";

export const Header = ({block, article = false}) => {
  return React.createElement(`h${article ? Math.max(2, Math.min(6, Number(block.data.level) || 2)) : block.data.level}`, {id: `title-${block.id}`},
    <span dangerouslySetInnerHTML={{__html: block.data.text}}/>)
}